export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7314.c95934e7.jpg";